import { LayoutType } from '@/container/context/layout/layout-context';
import { SortEnum, TeamsV2Query } from '@/types/generated/graphql';
import { Dispatch, SetStateAction } from 'react';

export type UseTeamsReturn = {
  data: TeamsV2Query['teamsV2'];
  setFilter: Dispatch<
    SetStateAction<{
      query: string;
      limit: number;
      order?: string;
      sort: SortEnum;
    }>
  >;
  hasNextPage: boolean;
  initialLoading: boolean;
};

export type SidebarTeamsProps = {
  teams: UseTeamsReturn;
  layoutContext: LayoutType;
};

export type SortTypeProps = {
  onChange: (value: SortEnum | '') => void;
};

export enum SelectTeamTypeEnum {
  createdAt = 'createdAt',
  name = 'name',
}

export enum SelectMemberTypeEnum {
  name = 'user.name',
  lastSeenAt = 'userOnlineManagement.lastSeenAt',
  createdAt = 'createdAt',
}
